import { render, staticRenderFns } from "./PpvTriageFilter.vue?vue&type=template&id=4b97aed5&scoped=true"
import script from "./PpvTriageFilter.vue?vue&type=script&lang=js"
export * from "./PpvTriageFilter.vue?vue&type=script&lang=js"
import style0 from "./PpvTriageFilter.vue?vue&type=style&index=0&id=4b97aed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97aed5",
  null
  
)

export default component.exports